module.exports = [{"name":"EMBEDDABLE","icon":{"type":"icon","name":"extensions"}},{"name":"CUSTOMIZABLE","icon":{"type":"icon","name":"color_lens"}},{"name":"MANAGEMENT","icon":{"type":"icon","name":"settings"}},{"name":"IMAGES","icon":{"type":"icon","name":"photo"}},{"name":"POST_HTML","icon":{"type":"icon","name":"star"}},{"name":"THEMES","icon":{"type":"icon","name":"build"}},{"name":"REPLY","icon":{"type":"icon","name":"reply"}},{"name":"CUSTOM_HTML","icon":{"type":"icon","name":"code"}},{"name":"IP_BAN","icon":{"type":"icon","name":"block"}}]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/guestbooks/service-garden.json
// module id = hPQn
// module chunks = 0